import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "models/NotificationAsset"

export interface IGetNotificationAssetOutOfOrderDto extends IGetNotification {
    notificationType: NotificationType.assetOutOfOrder
    assetId: Guid
}

export default class NotificationAssetOutOfOrder extends Notification {
    asset: NotificationAsset

    constructor(dto: IGetNotificationAssetOutOfOrderDto) {
        super(dto)
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
    }
}
